export const themeColor = (theme, colorString) => {
  // #000000 style colorString
  if (colorString?.startsWith('#')) {
    return colorString;
  }
  // primary.main style colorString
  if (colorString?.indexOf('.') > -1) {
    const [palette, shade] = colorString.split('.');
    return theme.palette[palette][shade]
      ? theme.palette[palette][shade]
      : theme.palette.common.black;
  }
  // primary style colorString
  return theme.palette.hasOwnProperty(colorString)
    ? theme.palette[colorString].main
    : theme.palette.common.black;
};

export const hexToRgb = (input) => {
  if (!input || typeof input !== 'string') {
    return '0, 0, 0';
  }

  if (input.startsWith('rgb')) {
    return input
      .replace(/rgba?\(/, '')
      .replace(')', '')
      .split(',')
      .slice(0, 3)
      .map((x) => x.trim())
      .join(', ');
  }

  let hex = input.replace('#', '').trim();
  if (hex.length === 3) {
    hex = hex
      .split('')
      .map((c) => c + c)
      .join('');
  }

  if (!/^[0-9a-fA-F]{6}$/.test(hex)) {
    return '0, 0, 0';
  }

  const bigint = parseInt(hex, 16);
  const r = (bigint >> 16) & 255;
  const g = (bigint >> 8) & 255;
  const b = bigint & 255;
  return `${r}, ${g}, ${b}`;
};
